import * as R from 'ramda'
import { Offer, PriceEstimation } from '../../../../types/types'
import { isFutureProportionalPrice } from 'app/app/common/offer'
import { getFutureCalendarDates } from 'app/app/common/common-utils'
import { sumTotalDiscountedPrice } from 'app/app/common/prices'

const getProportionalPriceEstimation = (offer: Offer): ReadonlyArray<PriceEstimation> | undefined => {
  const {
    priceEstimation = [],
    isEscalationFlow: { active, escalatedAnnualPrice, escalationVasDiscountedPrices }
  } = offer
  const price = active ? escalatedAnnualPrice + escalationVasDiscountedPrices : sumTotalDiscountedPrice(offer.prices)
  if (isFutureProportionalPrice(offer) && priceEstimation.length === 0) {
    return getFutureCalendarDates(
      (offer.commercialTerms.VBEGDAT as string) || '',
      (offer.commercialTerms.VABNDAT as string) || '',
      'YYYY-MM-DD',
      'YYYY-MM-DD'
    ).map((d, i) => (i === 0 ? { ...d, price } : { ...d, price: undefined }))
  }
  // TODO: for only future price?
  return offer.priceEstimation
}

export const setOfferPriceEstimation = (offer: Offer) => ({
  ...offer,
  priceEstimation: getProportionalPriceEstimation(offer)
})

export const resetOfferPriceEstimation = (offer: Offer) => ({
  ...offer,
  priceEstimation: resetBasePriceEstimation(offer)
})

export const resetEscalationFlowOfferPriceEstimation = (offer: Offer) => ({
  ...offer,
  priceEstimation: getProportionalPriceEstimation({ ...offer, priceEstimation: [] })
})

const resetBasePriceEstimation = ({ priceEstimation, prices, isEscalationFlow }: Offer) => {
  if (!priceEstimation) {
    return undefined
  }
  const { active, escalatedAnnualPrice, escalationVasDiscountedPrices } = isEscalationFlow
  const price = active ? escalatedAnnualPrice + escalationVasDiscountedPrices : sumTotalDiscountedPrice(prices)
  return R.head(priceEstimation) ? R.assocPath([0, 'price'], price, priceEstimation) : priceEstimation
}
